import { useMutation } from "@tanstack/react-query";
import { queryClient } from "../../..";
import putMovimento from "../queries/putMovimento";
import { MovimentoForm } from "../types";

export default function usePutMovimento(onSuccessEditMovimento: () => void) {
  return useMutation(
    ({
      movimentoAtual,
      id,
      data,
    }: {
      movimentoAtual: MovimentoForm;
      id: number;
      data: MovimentoForm;
    }) => {
      //@ts-ignore
      Object.keys(data as any).forEach((key: string) => data[key] === undefined && delete data[key]);

      Object.assign(movimentoAtual, data);

      return putMovimento(id, movimentoAtual, () => onSuccessEditMovimento());
    },
    {
      onSuccess(_, { id }) {
        queryClient.invalidateQueries();
      },
      onError(err: Error) {
        
      }
    }
  );
}
